import UserTag from 'app/components/UserTag'
import React from 'react'
import { Text } from 'styles/reactnative'

export const SllipageColmns = (mutate, openModal) => {
	return [
		{
			title: 'id',
			dataIndex: 'id',
		},
		{
			title: '그룹',
			dataIndex: 'referral_code',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '회원',
			dataIndex: 'id',
			width: 150,
			align: 'center',
			render: (text, data) => (
				<UserTag
					userid={data?.id}
					email={data?.email}
					nickname={data?.fullname || data?.nickname}
					phone={data?.phone}
					onClick={() => {
						openModal(data?.id)
					}}
				/>
			),
		},
		{
			title: 'ep_ids',
			dataIndex: 'ep_ids',
			render: (text, data) => {
				return <>{text?.toString()}</>
			},
		},
	]
}
